import { MEDIA } from "@/styles/common";
import { Box } from "@chakra-ui/react";

export const BackgroundBanner = ({ img_URL = undefined }: { img_URL?: string }) => {
    const { isMobile } = MEDIA();

    return (
        <Box position="relative" w="100%">
            <Box
                w="100%"
                h={isMobile ? "224px" : "480px"}
                bg={img_URL ? `url(${img_URL})center center / cover no-repeat fixed` : "gray.100"}
            />
            <Box zIndex="2" position="absolute" top="0" w="100%" h="100%" bg="rgba(0,0,0,0.2)" />
        </Box>
    );
};
